import React, { useContext, useEffect } from 'react';
import { Loader } from '@ferris/react/components/loader';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { shallowEqual, useSelector } from 'react-redux';
import { AGENTIC_JOIN_CREATION } from '../PageFlow/PageList';
import LeadCreateErrorAlert from '../ListYourPropertyPage/LeadForm/LeadCreateErrorAlert';
import { JOIN_SOURCES, JoinCtx } from '../../contexts/join';
import { createPageViewEvent } from '../../utils/EventProviders/EgClickstreamUtil';
import { UserCtx } from '../../contexts/user';

function AgenticJoinCreation() {
    const {
        createAgenticJoin
    } = useContext(JoinCtx);
    const { trigger } = useContext(TrackingContext);

    const getPropsFromState = (state) => {
        const { lead, hydration } = state;
        const { showLeadCreationError } = lead;
        const { hydrationComplete } = hydration;
        return {
            showLeadCreationError,
            hydrationComplete
        };
    };

    const {
        getBasicUserInformation
    } = useContext(UserCtx);
    const [userInformation, setUserInformation] = React.useState(null);
    const retrieveEpcUserInformation = async () => {
        const information = await getBasicUserInformation();
        setUserInformation(information);
    };
    useEffect(() => {
        retrieveEpcUserInformation();
    }, []);

    const {
        showLeadCreationError,
        hydrationComplete
    } = useSelector(getPropsFromState, shallowEqual);

    const agenticJoinCreationTrigger = async () => {
        await createAgenticJoin({
            source: userInformation.hasExistingProperties
                ? JOIN_SOURCES.AGENTIC_ONBOARDING_AAP : JOIN_SOURCES.AGENTIC_ONBOARDING_JEL,
            pageName: AGENTIC_JOIN_CREATION
        });
    };

    useEffect(() => {
        if (hydrationComplete && userInformation) {
            agenticJoinCreationTrigger();
        }
    }, [hydrationComplete, userInformation]);

    useEffect(() => {
        trigger('pageview', createPageViewEvent(
            'joinconfirmation',
            'AgenticJoinCreation',
            '1.12.1'
        ));
    }, []);

    return (
        <div className="update-account-wrapper">
            {
                showLeadCreationError ? (
                    <LeadCreateErrorAlert
                        isDismissable={false}
                        isConventionalLodgingFlow
                    />
                ) : (
                    <Loader visible />
                )
            }

        </div>
    );
}

AgenticJoinCreation.displayName = AGENTIC_JOIN_CREATION;
export default AgenticJoinCreation;
